export default __webpack_public_path__ + "static/a22-1b7e4c6998c552798928d8edd8548165.png";